import { GridSlotProps } from '@mui/x-data-grid-pro';
import { FormControlLabel } from '@mui/material';
import CheckBox from '../../../shared/components/Checkbox';

// Need to style checkbox to match, as well as add labels for Column Management...
// `GridColumnsManagementRow` uses a checkbox at its base checkbox, but we need to wrap that in a FormControlLabel to show the column name...
// refer to https://github.com/mui/mui-x/blob/master/packages/x-data-grid/src/components/columnsManagement/GridColumnsManagement.tsx line 460 for more details...
// the label is passed via props...
export default function GridCheckBox(props: GridSlotProps["baseCheckbox"]) {
    const { label, slotProps, ...rest } = props;

    return (
        label ? <FormControlLabel control={<CheckBox {...rest} slotProps={{ input: slotProps?.htmlInput }} />} label={label} /> : <CheckBox {...rest} slotProps={{ input: slotProps?.htmlInput }} />
    );
};